import { render } from "./RoomFrom.vue?vue&type=template&id=16effd2e"
import script from "./RoomFrom.vue?vue&type=script&lang=js"
export * from "./RoomFrom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__